import clsx from "clsx"
import { FC, memo, useMemo } from "react"
import { SpinnerCircular } from "spinners-react"
import { getStyles } from "@/helpers/getStyles"
import { Container } from "@/ui/Container"
import { IButton } from "."
import "./style.scss"

export const ButtonComponent: FC<IButton> = ({
  children,
  icon,

  triangleBottomPosLeft,
  triangleTopPosLeft,
  isLoading = false,
  classNameContainer,
  styles = "yellow",

  className,
  ...rest
}) => {
  const isDisabled = useMemo(
    () => isLoading || rest.disabled,
    [isLoading, rest.disabled]
  )

  return (
    <button
      {...rest}
      className={clsx("custom-button", className, getStyles(styles))}
      disabled={isDisabled}
    >
      <Container
        triangleTopPosLeft={
          triangleTopPosLeft === "none" ? undefined : triangleTopPosLeft
        }
        triangleBottomPosLeft={
          triangleBottomPosLeft === "none"
            ? undefined
            : triangleBottomPosLeft || "30%"
        }
        className={clsx("button-container", classNameContainer)}
      >
        {isLoading && (
          <SpinnerCircular
            className="loading-spinner"
            size={20}
            color="#35262699"
          />
        )}

        {isDisabled ? (
          <div className={clsx("children", { hidden: isLoading })}>
            {icon}
            {children}
          </div>
        ) : (
          <>
            {icon}
            {children}
          </>
        )}
      </Container>
    </button>
  )
}

export const Button = memo(ButtonComponent)
